import { connect, useDispatch } from "react-redux";
import { IEarlyAlerts } from "../../../../models/student/studentAcademicProfile";
import { useEffect } from "react";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { setApps } from "../../../../store/slices/master/appSlice";
import { getApps } from "../../../../action/masters/appActionCreator";
import { IApps } from "../../../../models/master/apps";
import { baseURL } from "../../../../constants/commonConstants";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const EarlyAlerts = (props: IEarlyAlerts) => {
  const { getAllEarlyAlerts, earlyAlerts, snapShots } = props;

  const dispatch = useDispatch();

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.earlyAlerts);

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getAllEarlyAlerts(pageBlockId.earlyAlerts, limit.one);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setApps([]));
    }
  }, []);

  const handleRedirect = (url: string) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <ul className="transactions-wrap early-alert-card mb-0">
            {earlyAlerts
              ?.filter((app: IApps) => app.displayOrNot)
              .map((app: IApps, index: number) => (
                <li className="card" key={index} onClick={() => handleRedirect(app.url)}>
                  <div className="img icon">
                    <img src={baseURL + app.image} alt="" />
                  </div>
                  <div>
                    <h3>{app.name}</h3>
                    <p className="para-hide-1">{app.description}</p>
                  </div>
                </li>
              ))}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getAllEarlyAlerts: (pageBlockId?: number, noOfItems?: number) =>
    getApps(undefined, pageBlockId, undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    earlyAlerts: state.app.appsForTerm,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EarlyAlerts);
